import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'lk-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  public articles: any;
  public publication: any;
  public users: any;
  public covers;
  public selectedCover;
  public menuOpen:boolean = false;

  constructor(private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {
    this.route.data
      .map( data => {
        return {
          publication: data.data[0],
          articles: data.data[1],
          users: data.data[2],
          covers: data.data[3].filter( cover => {
            if(cover.theme_data && typeof cover.theme_data !== 'object' )
              cover.theme_data = JSON.parse(cover.theme_data);

            return cover.jpg_image_file_name
          })
        };
      })
      .subscribe(
        ( data ) => {

          this.publication = data.publication;
          this.articles = data.articles;
          this.users = data.users;
          this.covers = data.covers;

          if(this.covers.length > 0)
            this.selectedCover = this.covers[0];

          console.log(this.covers);

          for (let article of this.articles) {
            switch (article.article_type)
            {
              case "1" :
                article.article_type = "Henkilöjuttu";
                break;
              case "2" :
                article.article_type = "Reportaasi";
                break;
              case "3" :
                article.article_type = "Kolumni / Pakina";
                break;
              default : console.log("no known type");
            }
          }

          console.log(this.publication);
          console.log(this.articles);
          console.log(this.users);
        }
      );

    this.route
      .queryParams
      .subscribe(
        data => {
          if(data.theme){
            const cover = this.covers.find(cover => cover.id == data.theme );
            if(cover){
              this.selectedCover = cover;
            }
          }
        }
      )
  }

  public navigate(){
    this.router.navigate([location.pathname], { queryParams: { theme: this.selectedCover.id }});
  }

  public getUserName(cover){
    const user = this.users.find(user => user.id == cover.user_id);
    return user.first_name + ' ' + user.last_name;
  }

  public toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/sidebar.component.ts